import {
  MAIL_TEMPLATE_VARIABLES,
  getMissingMailVariables,
} from "../../../../supabase/functions/_shared/mailTemplates";

export const TEMPLATE_FIELD_LABELS: Record<string, string> = {
  company_name: "Компания",
  contact_name: "Обращение к получателю",
  sender_name: "Подпись отправителя",
  proposal_url: "Ссылка на КП или описание вложения",
  meeting_summary: "Итоги встречи",
  next_step: "Следующий шаг",
  client_task: "Задача клиента",
  offer_scope: "Состав работ",
  offer_price: "Стоимость и НДС",
  offer_timing: "Сроки выполнения",
  offer_terms: "Условия оплаты и работы",
  offer_valid_until: "Срок действия предложения",
};

// Demonstration values only. Never use these when preparing a customer's draft.
export const TEMPLATE_PREVIEW_EXAMPLE: Record<string, string> = {
  company_name: "ООО «Пример»",
  contact_name: ", Анна",
  sender_name: "Сергей\nМенеджер проекта",
  proposal_url: "Предложение: https://example.org/proposal",
  meeting_summary: "Обсудили задачу, ожидаемый результат и порядок работы.",
  next_step: "Если условия подходят, ответьте на это письмо — согласуем старт.",
  client_task: "подготовить материалы для запуска нового направления.",
  offer_scope:
    "— Разбор исходных материалов\n— Подготовка решения\n— Согласование и передача результата",
  offer_price: "85 000 ₽, без НДС (пример)",
  offer_timing: "10 рабочих дней после получения материалов (пример)",
  offer_terms: "50% до начала работы, 50% после согласования (пример)",
  offer_valid_until: "30 сентября 2026 года (пример)",
};

export const getUnknownTemplateFields = (value: string) =>
  getMissingMailVariables(value).filter(
    (name) => !(MAIL_TEMPLATE_VARIABLES as readonly string[]).includes(name),
  );

export const getTemplateContext = ({
  companyName,
  recipientName,
  senderName,
}: {
  companyName: string;
  recipientName?: string;
  senderName?: string;
}): Record<string, string> => ({
  company_name: companyName,
  contact_name: recipientName ? `, ${recipientName}` : "",
  ...(senderName ? { sender_name: senderName } : {}),
});
